module.exports = __webpack_public_path__ + "img/icon_filter.02e215da.svg";